import fetch from "unfetch";
import { ApolloClient } from "apollo-client";
import { ApolloLink } from "apollo-link";
import ReduxLink from "apollo-link-redux";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import store from "../stores/reduxStore";

const link = ApolloLink.from([
    new ReduxLink(store),
    new HttpLink({
        uri: window._nounConfig.graphqlEndpoint,
        credentials: "include",
        fetch
    })
]);

export const clientOptions = {
    link,
    cache: new InMemoryCache()
};

const client = new ApolloClient(clientOptions);

export default client;
